import { render, staticRenderFns } from "./review-manage.vue?vue&type=template&id=4db5a672"
import script from "./review-manage.vue?vue&type=script&lang=ts"
export * from "./review-manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports